// DRF Error normalization utility for Auth-Portal
// Converts DRF field errors and detail messages to user-friendly strings

export const normalizeDrfError = (error) => {
  // If it's already a string, return as-is
  if (typeof error === 'string') {
    return error;
  }

  // If it's an Error object with data property (from @df/api enhanced errors)
  if (error && typeof error === 'object' && error.data) {
    const data = error.data;
    
    // Check for field-specific errors (e.g., { "email": ["This field is required."] })
    if (typeof data === 'object') {
      for (const [field, messages] of Object.entries(data)) {
        if (Array.isArray(messages) && messages.length > 0) {
          return messages[0]; // Return first field error
        }
      }
      
      // Check for detail message
      if (data.detail) {
        return data.detail;
      }
      
      // Check for non_field_errors
      if (data.non_field_errors && Array.isArray(data.non_field_errors) && data.non_field_errors.length > 0) {
        return data.non_field_errors[0];
      }
    }
  }

  // Fallback to error message or generic message
  return error?.message || 'An unexpected error occurred. Please try again.';
};

const looksLikeHtml = (value) =>
  typeof value === 'string' && value.trim().startsWith('<');

export const isNetworkError = (error) => {
  const message = String(error?.message || '');
  return (
    message.includes('Network') ||
    message.includes('Failed to fetch') ||
    message.includes('NetworkError')
  );
};

export const getSafeApiErrorMessage = (error, fallback) => {
  const data = error?.data;

  if (looksLikeHtml(data)) {
    return fallback;
  }
  if (data?.error?.message) return data.error.message;
  if (data?.detail) return data.detail;
  if (typeof data === 'string' && data.trim()) return data;
  if (data && typeof data === 'object') {
    const keys = Object.keys(data);
    if (keys.length > 0) {
      const first = data[keys[0]];
      if (Array.isArray(first) && first.length > 0) return String(first[0]);
      if (first) return String(first);
    }
  }

  if (looksLikeHtml(error?.message)) {
    return fallback;
  }
  return error?.message || fallback;
};

// Common error messages for auth flows
export const AUTH_ERROR_MESSAGES = {
  INVALID_CREDENTIALS: 'Invalid username or password. Please check your credentials and try again.',
  ACCOUNT_INACTIVE: 'Your account is not active. Please check your email for activation instructions.',
  TOKEN_EXPIRED: 'Your session has expired. Please log in again.',
  NETWORK_ERROR: 'Network error. Please check your connection and try again.',
  SERVER_ERROR: 'Server error. Please try again later.',
  RATE_LIMITED: 'Too many requests. Please wait a moment and try again.',
  VALIDATION_ERROR: 'Please check your input and try again.'
};
